export function preserveQueryParams(to: any, from: any, next: any) {
    const usePreviousQueryParams = !Object.keys(to.query).length && Object.keys(from.query).length;
    if (usePreviousQueryParams) {
        next({ ...to, query: from.query });
    } else {
        next();
    }
}
